export function isBase64(str) {
   // Comprueba si la cadena comienza con "data:image/"
   return str.startsWith("data:image/");
}